// DS6.7.1
import React from 'react';
import classnames from 'classnames';
import Tag from './Tag';
import RemovableTag from './RemovableTag';
import s from './TagList.scss';
const TagList = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { tags , size ='medium' , multiline , isTruncated , className , children  } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`size-${size}`], !multiline && s['scrollable'], className),
        ref: ref
    }, tags.map(({ tagname , href , isRemovable , isSelected , biData , className: tagClassName , onClick  })=>{
        const TagItem = isRemovable ? RemovableTag : Tag;
        return /*#__PURE__*/ React.createElement(TagItem, {
            key: tagname,
            size: size,
            href: href,
            isSelected: isSelected,
            onClick: onClick,
            biData: biData,
            isTruncated: isTruncated,
            className: classnames(s['tag-item'], tagClassName)
        }, tagname);
    }), children);
});
TagList.displayName = 'TagList';
export default TagList;
